import { useLocation, useNavigate, useParams } from 'react-router-dom';
import React from 'react';

// Compatibility layer for withRouter from React Router v5
export function withRouter(Component) {
  function WrappedComponent(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    
    // Create match object similar to v5
    const match = {
      params: params,
      path: location.pathname,
      url: location.pathname,
      isExact: true
    };
    
    return (
      <Component
        {...props}
        history={{
          push: (path, state) => navigate(path, { state }),
          replace: (path, state) => navigate(path, { replace: true, state }),
          goBack: () => navigate(-1),
          goForward: () => navigate(1),
          location: location
        }}
        location={location}
        match={match}
      />
    );
  }
  
  WrappedComponent.displayName = `withRouter(${Component.displayName || Component.name})`;
  return WrappedComponent;
}

export default withRouter;
